
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const DownloadZipCard = ({ onClick, disabled: disabledProp }) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);

  const isDisabled = disabledProp || isDownloading;

  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!onClick || isDisabled) return;
    setIsDownloading(true);
    try {
      await onClick();
    } catch (err) {
      console.error('Erro ao baixar ZIP:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className={styles.zipCardContainer}
      disabled={isDisabled}
      onClick={handleDownload}>
      <div className={styles.zipCardIconWrapper}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="#F25B68" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14 2V8H20" stroke="#F25B68" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <text x="7" y="16" fill="#F25B68" fontSize="6" fontWeight="bold">ZIP</text>
        </svg>
      </div>
      <div className={styles.zipCardContent}>
        <span className={styles.zipCardTitle}>{t('chatsocket.download_zip.card_title')}</span>
        <span className={styles.zipCardSubtitle}>{t('chatsocket.download_zip.card_subtitle')}</span>
      </div>
      <span className={styles.zipCardDownloadButton}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </button>
  );
};
